import React from 'react';
import { useSelector } from 'react-redux';

import CheckCircleIcon from '@videoblocks/react-icons/CheckCircle';
import { LegacyPrimaryButton as PrimaryButton } from '@videoblocks/storywind';

import { selectDetailsSignUpLink } from '../../../selectors/detailsSelectors';

const VALUE_PROPS: string[] = [
  'Unlimited downloads that support artists',
  '100% human-made stock library, curated for quality',
  'Time-saving features and AI-powered tools',
];

interface Props {
  cta: string;
}

// RFPC-1336: value-props sign-up box shown to visitors on the video detail page
// when the `messaging_updates` experiment is in the `test` variant. Matches
// Figma node 575:8658.
function SubscriptionValuePropsBox({ cta }: Props) {
  const signUpLink = useSelector(selectDetailsSignUpLink);

  return (
    <div
      className="bg-white text-gray-900 rounded-lg p-4 mb-3 text-left"
      data-cy="subscriptionValuePropsBox"
    >
      <h2 className="mt-0 mb-4 text-lg font-bold leading-6">
        Get all the creative essentials in one subscription
      </h2>

      <ul className="list-none p-0 m-0 mb-4">
        {VALUE_PROPS.map((valueProp) => (
          <li key={valueProp} className="flex items-start mb-2 last:mb-0">
            <CheckCircleIcon className="flex-shrink-0 w-4 h-4 mt-1 mr-2 fill-current text-blue-1000" />
            <span className="text-base leading-6">{valueProp}</span>
          </li>
        ))}
      </ul>

      <PrimaryButton
        className="block w-full text-center hover:no-underline rounded-lg"
        label={cta}
        href={signUpLink}
      />
    </div>
  );
}

export default SubscriptionValuePropsBox;
